<div *ngIf="formGroup"
     id="personNameEditForm"
     [formGroup]="formGroup">

  <!-- Human Name Type-->
  <ng-container *ngIf="entityType?.nameType === 'HumanName'">
    <div class="flex flexJustify--between mt-0050">
      <mat-form-field class="col col--050"
                      [hideRequiredMarker]="true">
        <mat-label>First Name</mat-label>
        <input matInput
               type="text"
               appAutofocus
               data-focus-id="firstName"
               data-test-id="firstNameInput"
               formControlName="firstName"
               (blur)="_onTouched()"
               autocomplete="off">
        <app-input-error [formControlItem]="formGroup.controls.firstName">
        </app-input-error>
      </mat-form-field>
      <mat-form-field class="col col--050"
                      [hideRequiredMarker]="true"
                      *ngIf="formGroup.value?.middleName || addMiddleNameButtonVisible">
        <mat-label>Middle Name</mat-label>
        <input matInput
               type="text"
               (blur)="_onTouched()"
               data-test-id="middleNameInput"
               formControlName="middleName"
               autocomplete="off">
      </mat-form-field>
      <mat-form-field class="col col--050"
                      [hideRequiredMarker]="true">
        <mat-label>Last Name</mat-label>
        <input matInput
               type="text"
               (blur)="_onTouched()"
               data-test-id="lastName"
               formControlName="lastName"
               autocomplete="off">
      </mat-form-field>
      <mat-form-field class="col col--050"
                      [hideRequiredMarker]="true"
                      *ngIf="formGroup.value?.nickname || addNicknameButtonVisible">
        <mat-label>Preferred Name</mat-label>
        <input matInput
               type="text"
               (blur)="_onTouched()"
               data-test-id="nickname"
               formControlName="nickname"
               autocomplete="off">
      </mat-form-field>


      <mat-form-field class="col col--050"
                      [hideRequiredMarker]="true"
                      *ngIf="formGroup.value?.suffix || addSuffixButtonVisible">
        <mat-label>Suffix</mat-label>
        <input matInput
               type="text"
               (blur)="_onTouched()"
               data-test-id="suffix"
               formControlName="suffix"
               autocomplete="off">
      </mat-form-field>


      <!--Note this is repeated for the single name type below-->

      <ng-container *ngIf="(formGroup.value?.pronouns || addPronounsButtonVisible) && entityType?.pronounsEnabled">
        <div [ngClass]="customPronounsVisible ? 'flex flexJustify--between w-100' : 'col col--050'">
          <mat-form-field [ngClass]="customPronounsVisible ? 'col col--050' : 'd-block' "
                          [hideRequiredMarker]="true">
            <mat-label>Pronouns</mat-label>
            <mat-select formControlName="pronounsSelect">
              <mat-option value=""></mat-option>
              <mat-option value="he/him">he/him</mat-option>
              <mat-option value="she/her">she/her</mat-option>
              <mat-option value="they/them">they/them</mat-option>
              <mat-option value="custom">Custom</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="col col--050"
                          *ngIf="customPronounsVisible"
                          [hideRequiredMarker]="true">
            <mat-label>Custom Pronouns</mat-label>
            <input matInput
                   type="text"
                   formControlName="customPronouns">
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <div class="flex flexJustify--end">

      <span class="link link--noline addBtn"
            (click)="addMiddleNameButtonVisible = true"
            data-test-id="showMiddleNameBtn"
            *ngIf="!addMiddleNameButtonVisible && !formGroup.value?.middleName">
        <i class="fal fa-plus"></i>
        Middle Name
      </span>
      <span class="link link--noline addBtn"
            (click)="addNicknameButtonVisible = true"
            data-test-id="showNicknameBtn"
            *ngIf="!addNicknameButtonVisible && !formGroup.value?.nickname">
        <i class="fal fa-plus"></i>
        Preferred Name
      </span>

      <span class="link link--noline addBtn"
            (click)="addSuffixButtonVisible = true"
            data-test-id="showSuffixBtn"
            *ngIf="!addSuffixButtonVisible && !formGroup.value?.suffix">
        <i class="fal fa-plus"></i>
        Suffix
      </span>

      <!-- AB-654 -->
      <span class="link link--noline addBtn"
            (click)="addPronounsButtonVisible = true"
            data-test-id="showPronounBtn"
            *ngIf="(!addPronounsButtonVisible && !formGroup.value?.pronouns) && entityType?.pronounsEnabled">
        <i class="fal fa-plus"></i>
        Pronouns
      </span>

    </div>
  </ng-container>
  <!-- /Human Name Type-->

  <!--Single Name Type-->
  <ng-container *ngIf="entityType?.nameType === 'SingleName'">
    <div class="flex flexJustify--between mt-0050">
      <mat-form-field class="col"
                      [hideRequiredMarker]="true">
        <mat-label>Name</mat-label>
        <input matInput
               type="text"
               (blur)="_onTouched()"
               data-test-id="singleName"
               data-focus-id="firstName"
               formControlName="firstName"
               appAutofocus
               autocomplete="off">
        <app-input-error [formControlItem]="formGroup.controls.firstName">
        </app-input-error>
      </mat-form-field>

      <mat-form-field class="col col--050"
                      [hideRequiredMarker]="true"
                      *ngIf="formGroup.value?.nickname || addNicknameButtonVisible">
        <mat-label>Preferred Name</mat-label>
        <input matInput
               type="text"
               (blur)="_onTouched()"
               data-test-id="nickname"
               formControlName="nickname"
               autocomplete="off">
      </mat-form-field>


      <ng-container *ngIf="(formGroup.value?.pronouns || addPronounsButtonVisible) && entityType?.pronounsEnabled">
        <mat-form-field class="col col--050"
                        [hideRequiredMarker]="true">
          <mat-label>Pronouns</mat-label>
          <mat-select formControlName="pronounsSelect">
            <mat-option value=""></mat-option>
            <mat-option value="he/him">he/him</mat-option>
            <mat-option value="she/her">she/her</mat-option>
            <mat-option value="they/them">they/them</mat-option>
            <mat-option value="custom">Custom</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col col--050"
                        *ngIf="customPronounsVisible"
                        [hideRequiredMarker]="true">
          <mat-label>Custom Pronouns</mat-label>
          <input matInput
                 type="text"
                 formControlName="customPronouns">
        </mat-form-field>
      </ng-container>
    </div>

    <div class="flex flexJustify--end">


      <span class="link link--noline addBtn"
            (click)="addNicknameButtonVisible = true"
            data-test-id="showNicknameBtn"
            *ngIf="!addNicknameButtonVisible && !formGroup.value?.nickname">
        <i class="fal fa-plus-circle"></i>
        Preferred Name
      </span>

    </div>
  </ng-container>
  <!-- / Single Name type-->

</div>
